export default __webpack_public_path__ + "static/media/youtube-icon.dfa65fdf.svg";